(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function bind() {
      document.querySelectorAll("[data-menu-toggle]:not([data-bound])").forEach(function (btn) {
        btn.setAttribute("data-bound", "");
        var header = btn.closest("header");
        function setOpen(open) {
          header.classList.toggle("is-open", open);
          btn.setAttribute("aria-expanded", open ? "true" : "false");
        }
        btn.addEventListener("click", function () {
          setOpen(!header.classList.contains("is-open"));
        });
        // Close after picking a link, on Escape, or when tapping outside the menu.
        header.querySelectorAll("nav.links a").forEach(function (a) {
          a.addEventListener("click", function () { setOpen(false); });
        });
        document.addEventListener("keydown", function (e) {
          if (e.key === "Escape" && header.classList.contains("is-open")) { setOpen(false); btn.focus(); }
        });
        document.addEventListener("click", function (e) {
          if (!header.contains(e.target)) setOpen(false);
        });
      });
    }
    bind();
    document.addEventListener("shopify:section:load", bind);
  })();

  } catch(e) { console.error(e); }
})();
})();
